<template>
  <v-card>
    <v-card-title class="text-h6 font-weight-bold">
      옵션 상품 선택
      <v-spacer></v-spacer>
      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-alert v-if="loading" type="info" text> 옵션 상품을 불러오는 중입니다... </v-alert>

      <v-alert v-else-if="error" type="error" text>
        {{ error }}
      </v-alert>

      <div v-else>
        <v-alert v-if="optionProducts.length === 0" type="info" text> 등록된 옵션 상품이 없습니다. </v-alert>

        <div v-else>
          <div class="mb-3 text-body-2 grey--text">여러 개의 옵션 상품을 선택할 수 있습니다.</div>

          <div class="option-products-list">
            <OptionProductCard v-for="product in optionProducts" :key="product.id" :option-product="product" :value="isSelected(product.id)" @toggle="toggleSelection" />
          </div>
        </div>
      </div>
    </v-card-text>

    <v-card-actions class="pa-4">
      <div class="text-body-2 grey--text">{{ selectedProducts.length }}개 선택됨</div>
      <v-spacer></v-spacer>
      <v-btn large color="primary" @click="close">
        <v-icon left>mdi-close</v-icon>
        완료
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import OptionProductCard from "./OptionProductCard.vue"

export default {
  name: "OptionProductSelectDialog",
  components: {
    OptionProductCard,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    selectedProducts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      error: null,
      optionProducts: [],
    }
  },
  mounted() {
    this.fetchOptionProducts()
  },
  methods: {
    async fetchOptionProducts() {
      this.loading = true
      this.error = null

      try {
        const response = await this.$http.get("/api/option-products/select")
        this.optionProducts = response.data || []
      } catch (error) {
        console.error("옵션 상품 로드 실패:", error)
        this.error = "옵션 상품을 불러오는데 실패했습니다."
      } finally {
        this.loading = false
      }
    },

    isSelected(productId) {
      return this.selectedProducts.some((p) => p.id === productId)
    },

    toggleSelection(product) {
      this.$emit("toggle", product)
    },

    close() {
      this.$emit("input", false)
    },
  },
}
</script>

<style scoped>
.option-products-list {
  max-height: 400px;
  overflow-y: auto;
}
</style>
